import {useCallback} from 'react';
import {useCookie, useMount} from 'react-use';

import {useIsYandexPublisher} from 'client/common/hooks/user';
import {usePollStart} from 'client/common/hooks/poll';

import {sendGoal} from 'client/common/utils/metrika';
import {BannerGoal} from 'client/common/types/metrika';

import {BAROMETR} from 'client/quicksurvey/list/components/banner/banner-configs';

export function useBarometrCookie() {
    const [isBannerCookie, setIsBannerCookie] = useCookie('pythia-barometr-poll-4827');
    const isYandexPublisher = useIsYandexPublisher();

    const handleClose = useCallback(() => {
        setIsBannerCookie('close', {expires: 3, sameSite: 'Lax', secure: true});
        sendGoal(BannerGoal.ActionClickCloseBanner);
    }, [setIsBannerCookie]);

    const linksQueryParams = {yandexoid: String(isYandexPublisher)};
    const onStart = usePollStart(BAROMETR.slug, linksQueryParams);

    useMount(async () => {
        if (isBannerCookie) {
            return;
        }

        try {
            const {status} = await onStart();

            setIsBannerCookie(status === 200 ? '' : String(status), {
                expires: 30,
                sameSite: 'Lax',
                secure: true
            });
        } catch (error) {
            console.warn(error);

            setIsBannerCookie('error', {expires: 3, sameSite: 'Lax', secure: true});
        }
    });

    return {isBannerCookie, linksQueryParams, handleClose};
}
